import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { getDrivers } from "../../api/driver";
import { RESET } from "../types";

export const loadDrivers = createAsyncThunk(
  "drivers/loadDrivers",
  async ({ newSearch = true }, { getState, dispatch }) => {
    try {
      const state = getState().drivers;
      const page = newSearch ? 1 : state.page;

      const params = { page };
      const { data } = await getDrivers(params);

      const showButtonMore = data.length > 0;

      return {
        drivers: data,
        page: page + 1,
        showButtonMore: showButtonMore,
      };
    } catch (error) {
      console.error(error);
      throw new Error("Failed to update orders");
    }
  }
);

const driversAdapter = createEntityAdapter({
  selectId: (driver) => driver.driver_id,
  sortComparer: (a, b) => b.name - a.name,
});

const driversSlice = createSlice({
  name: "drivers",
  initialState: driversAdapter.getInitialState({
    page: 1,
    loadingDrivers: false,
    showButtonMore: true,
    showDriversListModal: false,
    showSelectOrderDriverModal: false,
    showSelectOrderToDriverModal: false,
    selectOrderDriverModalOrder: undefined,
    selectedOrderDriverId: undefined,
    selectedDriver: undefined,
  }),
  reducers: {
    setShowDriversListModal: (state, action) => {
      state.showDriversListModal = action.payload;
    },
    setShowSelectOrderDriverModal: (state, action) => {
      state.showSelectOrderDriverModal = action.payload;
    },
    setShowSelectOrderToDriverModal: (state, action) => {
      state.showSelectOrderToDriverModal = action.payload;
    },
    setSelectOrderDriverModalOrder: (state, action) => {
      state.showSelectOrderDriverModal = action.payload.show;
      state.selectOrderDriverModalOrder = action.payload.order;
    },
    setSelectedOrderDriverId: (state, action) => {
      state.selectedOrderDriverId = action.payload;
    },
    setSelectedDriver: (state, action) => {
      state.selectedDriver = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadDrivers.fulfilled, (state, action) => {
        driversAdapter.setAll(state, action.payload.orders);
        state.page = action.payload.page;
        state.showButtonMore = action.payload.showButtonMore;
        state.loadingOrders = false;
      })
      .addCase(RESET, () => driversAdapter.getInitialState())
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.error = action.error.message;
        }
      );
  },
});

export const {
  setShowDriversListModal,
  setShowSelectOrderDriverModal,
  setShowSelectOrderToDriverModal,
  setSelectOrderDriverModalOrder,
  setSelectedOrderDriverId,
  setSelectedDriver,
} = driversSlice.actions;
export default driversSlice.reducer;
